<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-sub-title text="Filtros"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="5">
                <app-form-select-input
                    v-model="filters.year"
                    placeholder="Año"
                    :options="years"
                />
            </b-col>
            <b-col cols="12" md="5">
                <app-form-select-input
                    v-model="filters.period"
                    placeholder="Periodo"
                    :options="months"
                />
            </b-col>
            <b-col cols="12" md="2" class="right-spaced">
                <b-btn
                    variant="primary"
                    :disabled="!filters.year || !filters.period"
                    @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn
                    variant="success"
                    :disabled="!filters.year || !filters.period"
                    @click="exportData"
                    ><i class="fa fa-download"></i
                ></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: 'management_indicators_filters',
    data: () => ({
        filters: {
            year: '',
            period: '',
        },
        executive: '',
    }),
    computed: {
        ...mapGetters(['months', 'years', 'executives']),
    },
    methods: {
        filter() {
            const filters = { ...this.filters }
            this.$emit('filter', filters)
        },
        exportData() {
            this.$emit('export', { ...this.filters })
        },
    },
    created() {
        this.load('months')
        this.load('years')
        this.load('supervisors')
    },
}
</script>
